import React, { ComponentType } from 'react'
import { SITE_STYLES, SITE_FONTS } from '@wix/thunderbolt-symbols'

export type SiteStylesCompProps = {
	css: string
	fonts?: string
	id?: string
}

const SiteStyles: ComponentType<SiteStylesCompProps> = ({ css, fonts, id = SITE_STYLES }) => (
	<>
		{css ? <style id={id} dangerouslySetInnerHTML={{ __html: css }} /> : null}
		{fonts ? <style id={SITE_FONTS} dangerouslySetInnerHTML={{ __html: fonts }} /> : null}
	</>
)

export default SiteStyles
